import withModal from '@/Components/Modals/withModalHOC';
import ShowToast from '@/Components/Toast/showToastTemplate';
import { Button, Link } from '@/Components/UI/Button/Button';
import Modal from '@/Components/UI/Modal/Modal';
import { post } from '@/Utils/API';
import {
  LINK_TEAMS_SUPPORT,
  MODAL_CONFIRM_LEAVE_TEAM,
  TOAST_TEXT_GENERAL_SPREADSHEET_ERROR,
  TOAST_TYPE_ERROR,
} from '@/Utils/constants';
import { throwNewErrorWithMessage } from '@/Utils/utils';

const ConfirmLeaveTeamModal = ({ show, hideModal }) => {
  const removeUserFromTeam = async () => {
    const endpoint = 'user/remove-from-team';
    try {
      const response = await post(endpoint);
      if (response?.Success) {
        window.location.reload();
      } else {
        throwNewErrorWithMessage(response?.Message);
      }
    } catch (error) {
      ShowToast({
        type: TOAST_TYPE_ERROR,
        text: error?.message || TOAST_TEXT_GENERAL_SPREADSHEET_ERROR,
        endpoint: endpoint,
        fileAndFunction: '__FILE_AND_FUNCTION_NAME__',
      });
    } finally {
      hideModal();
    }
  };

  return (
    <Modal size='x-small' withoutTitle={true} isOpen={show} onClose={hideModal}>
      <div className='flex flex-col items-center justify-between gap-6 text-center'>
        <div className='flex flex-col gap-2'>
          <div className='text-xl font-bold text-ocean-blue-900'>Are you sure?</div>
          <div className='px-2 text-sm'>
            Please{' '}
            <Link to={LINK_TEAMS_SUPPORT} target='_blank' size='medium'>
              contact support
            </Link>{' '}
            or your team admin to get reinstated.
          </div>
        </div>
        <div className='flex flex-row justify-end gap-4 mb-2'>
          <Button onClick={hideModal}>Cancel</Button>
          <Button onClick={removeUserFromTeam} color='oceanBlue'>
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default withModal({ name: MODAL_CONFIRM_LEAVE_TEAM })(ConfirmLeaveTeamModal);
